import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { initSentry } from './lib/sentry';
import { initAnalytics } from './lib/analytics';
import { AuthProvider } from './lib/auth';
import { I18nProvider } from './lib/i18n';
import { App } from './App';
import './styles.css';

initSentry();
initAnalytics();

// Chunk viejo tras un deploy: si un usuario tiene una pestaña abierta con el index.html
// cacheado y hacemos deploy, los chunks con hash cambian → "Failed to fetch dynamically
// imported module". Recargamos UNA vez (guard de 10s en sessionStorage para no hacer loop)
// para tomar el bundle nuevo, en vez de romper con el error boundary.
window.addEventListener('vite:preloadError', (e) => {
  const KEY = 'chunk_reload_at';
  const last = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - last > 10000) {
    sessionStorage.setItem(KEY, String(Date.now()));
    e.preventDefault();
    window.location.reload();
  }
});

/** Fallback cuando un componente crashea: el error ya se reportó a Sentry. */
function Crashed() {
  return (
    <div style={{ padding: 40, textAlign: 'center', color: '#1F2A44' }}>
      <h2>Something went wrong · Algo salió mal.</h2>
      <p style={{ color: '#6B7280' }}>The error was reported. Reload the page to continue. · El error se reportó. Recargá la página para continuar.</p>
      <button className="btn" onClick={() => window.location.reload()} style={{ marginTop: 12 }}>
        Reload · Recargar
      </button>
    </div>
  );
}

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<Crashed />}>
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
